import { render, staticRenderFns } from "./editor_right.vue?vue&type=template&id=5c21fc86"
import script from "./editor_right.vue?vue&type=script&lang=js"
export * from "./editor_right.vue?vue&type=script&lang=js"
import style0 from "./editor_right.vue?vue&type=style&index=0&id=5c21fc86&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports